import { GROUP } from '~/consts';

export default {
  data() {
    return {
      loading_invite: false,
      invite_success: false,
      loading_accept_request_join: false,
      members: [],
      memberDataProvider: {
        page: {
          current: 1,
          limit: 15,
        },
      },
      loading_join_group: false,
      leaveClass: {
        errorMessage: ''
      },
      loading_leave_class: false,
      loading_delete_group: false,
      verificationCode: null
    }
  },

  methods: {
    onAccept(data) {

    },
    onDeclined(data) {

    },
    onKick(data) {

    },
    accept(gm_id, group_id) {
      const vm = this;

      if (this.loading_accept_request_join) {
        return;
      }

      this.loading_accept_request_join = true;

      this.$axios.post(GROUP.ACCEPT(gm_id, group_id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onAccept(data)
          } else {
            toast.danger(data.applicationSystem.message);
          }

          this.loading_accept_request_join = false;
        }).catch(() => {
          this.loading_accept_request_join = false;
        });
    },
    decline(gm_id, group_id) {
      const vm = this;

      this.$axios.post(GROUP.DECLINE(gm_id, group_id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onDeclined(data)
          } else {
            toast.danger(data.applicationSystem.message);
          }
        }).catch(() => {

        });
    },
    kick(gm_id) {
      const vm = this;

      this.$buefy.dialog.confirm({
        message: 'Anda yakin ingin mengeluarkan anggota tersebut?',
        cancelText: 'Batal',
        confirmText: 'Saya yakin',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$axios.post(GROUP.KICK(gm_id))
            .then(({ data }) => {
              if (data.applicationSystem.code == 0) {
                vm.onKick(data)
              } else {
                toast.danger(data.applicationSystem.message);
              }
            }).catch(() => {

            })
        }
      })
    },
    asAdmin(gm_id) {
      this.$buefy.dialog.confirm({
        message: 'Anda yakin ingin menjadikan Admin, anggota tersebut?',
        cancelText: 'Batal',
        confirmText: 'Saya yakin',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$axios.post(GROUP.AS_ADMIN(gm_id))
            .then(({ data }) => {
              if (data.applicationSystem.code == 0) {
                this.onKick(data);
              } else {
                toast.danger(data.applicationSystem.message);
              }
            }).catch(() => {

            })
        }
      })
    },
    asMember(gm_id) {
      this.$buefy.dialog.confirm({
        message: 'Anda yakin ingin menurunkan jadi anggota, admin tersebut?',
        cancelText: 'Batal',
        confirmText: 'Saya yakin',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$axios.post(GROUP.AS_MEMBER(gm_id))
            .then(({ data }) => {
              if (data.applicationSystem.code == 0) {
                this.onKick(data)
              } else {
                toast.danger(data.applicationSystem.message);
              }
            }).catch(() => {

            })
        }
      })
    },

    onGroupLeftedSuccess() {},
    onGroupLeftedFailed() {},
    leave(group_id) {
      const vm = this;

      this.verificationCode = this.randomString(6, true);
      this.$buefy.dialog.confirm({
        message: `
          <p class="font-16">Mohon mengetikkan 5 kode di bawah ini, sebagai tanda Anda setuju untuk keluar dari kelas ini.</p>
          <div class="field">
            <div class="control">
              <input class="input" readonly style="font-size: 20px; padding: 24px 15px; font-weight: 400; border: 2px dashed #dbdbdb; background: #f7f7f7;" value="${this.verificationCode}"/>
            </div>
          </div>
          <div class="field" id="${this.verificationCode}">
            <div class="control">
              <input type="text" required="required" class="input" style="font-size: 20px; padding: 24px 15px; font-weight: 400; border: 2px dashed rgb(219, 219, 219);">
            </div>
            <p id="errorMessage" class="help is-danger" style="display: none;">Please fill out this field.</p>
          </div>
        `,
        confirmText: 'KELUAR',
        cancelText: 'Batal',
        type: 'is-danger',
        trapFocus: true,
        canCancel: ['escape', 'button'],
        closeOnConfirm: false,
        onConfirm: (v, { close }) => {
          const fieldEl = $(`.field[id="${this.verificationCode}"]`);
          const value = fieldEl.find('input').val().trim();
          const errorMessageEl = fieldEl.find('p#errorMessage');
          errorMessageEl.hide();
          if (this.loading_leave_class) {
            return;
          }

          if (this.isEmpty(value)) {
            errorMessageEl.text(`Kode harus diisi`).show();
            return;
          }

          if (value === `${this.verificationCode}`.trim()) {
            this.loading_leave_class = true;
            this.$axios.post(GROUP.LEAVE(group_id))
              .then(({ data }) => {
                if (data.applicationSystem.code == 0) {
                  close();
                  errorMessageEl.hide();
                  this.$buefy.dialog.alert({
                    message: data.applicationSystem.message,
                    hasIcon: true,
                    icon: 'check-circle',
                    iconPack: 'fa',
                    canCancel: false,
                    type: 'is-primary',
                    onConfirm: () => {
                      vm.onGroupLeftedSuccess(data)
                    }
                  })
                } else {
                  errorMessageEl.text(`Gagal keluar kelas`).show();
                  vm.onGroupLeftedFailed()
                }

                this.loading_leave_class = false;
              }).catch(() => {
                errorMessageEl.text(`Gagal keluar kelas`).show();
                this.loading_leave_class = false;
                vm.onGroupLeftedFailed()
              })
          } else {
            this.loading_leave_class = false;
            errorMessageEl.text(`Kode verifikasi salah, silakan masukkan kode dengan benar.`).show();
          }
        }
      });
    },

    onGetMembersSuccess() {},
    onGetMembersFailed() {},
    getMembers(group_id, refresh = false) {
      const vm = this;

      if (refresh) {
        vm.memberDataProvider.page['current'] = 1
      }

      this.$axios.post(GROUP.GET_PAGINATED_MEMBERS(group_id), {
        dataProvider: JSON.stringify(vm.memberDataProvider)
      })
        .then(({data}) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetMembersSuccess(data, refresh);
          } else {
            vm.onGetMembersFailed();
          }
        }).catch(() => {
          vm.onGetMembersFailed();
        });
    },

    onInviteJoinClassSuccess() {},
    onInviteJoinClassFailed() {},
    inviteJoinClass(group_id, data) {
      const vm = this

      if (this.isEmpty(data.emails)) {
        return;
      }

      vm.loading_invite = true
      this.$axios.post(GROUP.INVITE(group_id), {
        emails: data.emails
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onInviteJoinClassSuccess(data);
          } else {
            vm.onInviteJoinClassFailed(data);
          }

          vm.loading_invite = false
        })
        .catch(() => {
          vm.loading_invite = false
          vm.onInviteJoinClassFailed({
            message: 'Gagal memproses permintaan, cobalah beberapa saat lagi'
          });
        })
    },

    onJoinSuccess() {},
    onJoinFailed() {},
    join(id) {
      const vm = this;

      vm.loading_join_group = true;

      this.$axios.post(GROUP.JOIN_GROUP_PUBLIC(id))
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.onJoinSuccess(data)
        } else {
          vm.onJoinFailed(data);
        }

        vm.loading_join_group = false;
      }).catch(() => {
        vm.loading_join_group = false;
      })
    },

    isAdminGroup(group) {
      if (group.type === 'ACADEMIC') {
        const admin_account_ids = collect(group.groupAdmins).pluck('universityUserId').toArray();

        if ((!this.isEmpty(this.auth.activeAccount) && this.auth.activeAccount.type == 'ADMIN' && this.auth.activeAccount.universityId == group.universityId) || admin_account_ids.indexOf(this.auth.activeAccount.id) > -1) {
          return true
        }

        return false;
      } else {
        const admin_account_ids = collect(group.groupAdmins).pluck('userId').toArray();

        if (admin_account_ids.indexOf(this.auth.id) > -1) {
          return true
        }

        return false;
      }
    },
    onConfirmDeleteGroup(group) {
      if (this.loading_delete_group) {
        return;
      }

      this.loading_delete_group = true;
      if (this.isAdminGroup(group)) {
        this.$axios.post(GROUP.REMOVE_GROUP(group.id))
          .then(({ data }) => {
            if (data.applicationSystem.code == 0) {
              this.$store.dispatch('getStorageUsed');
              this.$buefy.dialog.alert({
                message: data.applicationSystem.message,
                hasIcon: true,
                icon: 'check-circle',
                iconPack: 'fa',
                canCancel: false,
                type: 'is-primary',
                onConfirm: () => {
                  this.onGroupLeftedSuccess();
                }
              })
            }

            this.loading_delete_group = false;
          }).catch(() => {
            this.loading_delete_group = false;
          })
      }
    },
    requestToDelete(group) {
      this.$buefy.dialog.confirm({
        message: 'Penghapusan kelas akan menghapus <strong>SEMUA DATA</strong> seperti <strong>Sesi, Laporan, Materi, Tugas, Quiz & Video Conference. <span class="has-text-danger">Data yang dihapus TIDAK AKAN BISA DIKEMABALIKAN LAGI</span></strong>. Apakah Anda yakin untuk melanjutkan hapus kelas?',
        confirmText: 'Saya Yakin',
        cancelText: 'Batal',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.verificationCode = this.randomString(6, true);
          this.$buefy.dialog.confirm({
            message: `
              <p class="font-16">Mohon mengetikkan 5 kode di bawah ini, sebagai tanda Anda setuju untuk keluar dari kelas ini.</p>
              <div class="field">
                <div class="control">
                  <input class="input" readonly style="font-size: 20px; padding: 24px 15px; font-weight: 400; border: 2px dashed #dbdbdb; background: #f7f7f7;" value="${this.verificationCode}"/>
                </div>
              </div>
              <div class="field" id="${this.verificationCode}">
                <div class="control">
                  <input type="text" required="required" class="input" style="font-size: 20px; padding: 24px 15px; font-weight: 400; border: 2px dashed rgb(219, 219, 219);">
                </div>
                <p id="errorMessage" class="help is-danger" style="display: none;">Please fill out this field.</p>
              </div>
            `,
            confirmText: 'HAPUS',
            cancelText: 'Batal',
            type: 'is-danger',
            trapFocus: true,
            canCancel: ['escape', 'button'],
            closeOnConfirm: false,
            onConfirm: (v, { close }) => {
              const fieldEl = $(`.field[id="${this.verificationCode}"]`);
              const value = fieldEl.find('input').val().trim();
              const errorMessageEl = fieldEl.find('p#errorMessage');
              errorMessageEl.hide();
              if (this.loading_leave_class) {
                return;
              }

              if (this.isEmpty(value)) {
                errorMessageEl.text(`Kode harus diisi`).show();
                return;
              }

              if (value === `${this.verificationCode}`.trim()) {
                this.loading_leave_class = true;
                this.onConfirmDeleteGroup(group);
                this.$nextTick(() => {
                  close();
                });
                close();
              } else {
                this.loading_leave_class = false;
                errorMessageEl.text(`Kode verifikasi salah, silakan masukkan kode dengan benar.`).show();
              }
            }
          });
        }
      });
    },
  }
}
